<div class="payment-content">
  <!-- Header row (hidden when embedded in a parent that already shows its own title) -->
  <div class="payment-header" *ngIf="showHeader">
    <h3 class="section-title">{{ sectionTitle }}</h3>
    <span class="show-summary-text" (click)="toggleOrderSummary()" style="cursor:pointer;">
      {{ showOrderSummary ? 'Hide Summary' : 'Show Summary' }}
    </span>
  </div>

  <!-- Tap to Pay status overlay -->
  <div *ngIf="taptopayLoading || showPaymentFailedOverlay" class="payment-status-overlay">
    <div class="payment-status-card" *ngIf="taptopayLoading && !showPaymentFailedOverlay">
      <div class="payment-status-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <h2 class="payment-status-title">{{ tapToPayStatusText }}</h2>
      <p class="payment-status-text">{{ tapToPayStatusSubText }}</p>
      <div class="payment-status-spinner"><div class="loading-spinner"></div></div>
      <br>
      <button class="btn btn-primary btn-large" (click)="stopPaymentStatusPolling()">Close</button>
    </div>
    <div class="payment-status-card" *ngIf="showPaymentFailedOverlay">
      <div class="payment-status-icon payment-status-icon--error">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M15 9L9 15M9 9L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      </div>
      <h2 class="payment-status-title">Payment Failed</h2>
      <p class="payment-status-text" *ngIf="paymentFailureMessage; else defaultFailMsg">{{ paymentFailureMessage }}</p>
      <ng-template #defaultFailMsg><p class="payment-status-text">The payment could not be processed. Please try again.</p></ng-template>
      <div style="display:flex;gap:12px;justify-content:center;margin-top:16px;">
        <button class="btn btn-primary btn-large" (click)="retryTapToPayPayment()">Retry</button>
        <button class="btn btn-secondary btn-large" (click)="resetPaymentTracking()">Cancel</button>
      </div>
    </div>
  </div>

  <div class="white-pane">
    <div class="scrollable-content">

      <!-- Order Summary -->
      <div *ngIf="showOrderSummary" class="order-summary-section">
        <div class="summary-container">
          <div class="service-details-card">
            <div class="service-card-header">
              <div class="service-provider">{{ summary.packageName || 'Car Wash Service' }}</div>
            </div>
            <div class="service-details-list">
              <div class="service-detail-item">
                <img src="assets/images/payment-summary/clipboard-list.svg" alt="service" class="service-icon"/>
                <span class="service-detail-text">{{ summary.packageName }}</span>
              </div>
              <div class="service-detail-item" *ngIf="summary.vehicleMake">
                <img src="assets/images/payment-summary/car.svg" alt="vehicle" class="service-icon"/>
                <span class="service-detail-text">{{ summary.vehicleYear }} {{ summary.vehicleMake }} {{ summary.vehicleModel }}</span>
              </div>
            </div>
            <div class="service-card-footer">
              <div class="service-price-container">
                <span class="service-price">${{ priceBreakdown.subtotal.toFixed(2) }}</span>
                <span class="service-price-period" *ngIf="isMonthly">/month</span>
              </div>
            </div>
            <div class="membership-disclaimer" *ngIf="isMonthly">
              The car wash membership auto-renews and can be managed anytime from the customer's account settings.
            </div>
          </div>

          <div class="price-breakdown">
            <div class="price-breakdown-list">
              <div class="price-breakdown-left">
                <div class="price-row"><span class="price-label">Subtotal</span></div>
                <div class="price-row"><span class="price-label">Taxes and Fees</span></div>
                <div class="price-row total-row"><span class="price-label total-label">Grand Total</span></div>
              </div>
              <div class="price-breakdown-right">
                <div class="price-row"><span class="price-value">${{ priceBreakdown.subtotal.toFixed(2) }}</span></div>
                <div class="price-row"><span class="price-value">${{ priceBreakdown.tax.toFixed(2) }}</span></div>
                <div class="price-row total-row"><span class="price-value total-value">${{ priceBreakdown.total.toFixed(2) }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Methods -->
      <div class="payment-methods" [class.compact]="showMorePaymentMethods">

        <!-- Tap to Pay — only when Android WebView exposes `TapToPayAndroid` -->
        <div class="payment-method"
             *ngIf="isTapToPayNativeHost"
             [class.selected]="paymentForm.method === PaymentMethodCode.TapToPay"
             (click)="selectPaymentMethod(PaymentMethodCode.TapToPay)">
          <div class="method-content">
            <div class="method-icon" *ngIf="!showMorePaymentMethods">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                <path d="M6 10H18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14Z" fill="currentColor"/>
                <path d="M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z" fill="currentColor"/>
                <path d="M16 14C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12C15.4477 12 15 12.4477 15 13C15 13.5523 15.4477 14 16 14Z" fill="currentColor"/>
              </svg>
            </div>
            <div class="method-info">
              <div class="method-title">Tap to Pay</div>
              <div class="method-description">Open the app to process payment</div>
            </div>
          </div>
          <div class="method-radio" [class.checked]="paymentForm.method === PaymentMethodCode.TapToPay"></div>
        </div>

        <!-- Cash -->
        <div class="payment-method"
             [class.selected]="paymentForm.method === PaymentMethodCode.Cash"
             [class.disabled]="isCashDisabled"
             (click)="!isCashDisabled && selectPaymentMethod(PaymentMethodCode.Cash)">
          <div class="method-content">
            <div class="method-icon" *ngIf="!showMorePaymentMethods">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.72-2.92-.01-1.56-1.19-2.45-3.61-3.01z" fill="currentColor"/>
              </svg>
            </div>
            <div class="method-info">
              <div class="method-title">Cash</div>
              <div class="method-description">Confirm cash payment received</div>
            </div>
          </div>
          <div class="method-radio" [class.checked]="paymentForm.method === PaymentMethodCode.Cash"></div>
        </div>

        <!-- Card -->
        <div class="payment-method"
             [class.selected]="paymentForm.method === PaymentMethodCode.Card"
             (click)="selectPaymentMethod(PaymentMethodCode.Card)">
          <div class="method-content">
            <div class="method-icon" *ngIf="!showMorePaymentMethods">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
                <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </div>
            <div class="method-info">
              <div class="method-title">Card Payment</div>
              <div class="method-description">Enter card details to make payment</div>
            </div>
          </div>
          <div class="method-radio" [class.checked]="paymentForm.method === PaymentMethodCode.Card"></div>
        </div>

        <!-- DRB Membership -->
        <div class="payment-method"
             [class.selected]="paymentForm.method === 'DRB Membership'"
             (click)="selectPaymentMethod('DRB Membership')">
          <div class="method-content">
            <div class="method-icon" *ngIf="!showMorePaymentMethods">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="method-info">
              <div class="method-title">DRB Membership</div>
              <div class="method-description">Use DRB membership for payment</div>
            </div>
          </div>
          <div class="method-radio" [class.checked]="paymentForm.method === 'DRB Membership'"></div>
        </div>

        <!-- Expanded methods -->
        <ng-container *ngIf="showMorePaymentMethods">
          <div class="payment-method"
               [class.selected]="paymentForm.method === PaymentMethodCode.Link"
               (click)="selectPaymentMethod(PaymentMethodCode.Link)">
            <div class="method-content">
              <div class="method-icon" *ngIf="!showMorePaymentMethods">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="method-info">
                <div class="method-title">Payment Link</div>
                <div class="method-description">Send payment link to customer</div>
              </div>
            </div>
            <div class="method-radio" [class.checked]="paymentForm.method === PaymentMethodCode.Link"></div>
          </div>

          <div class="payment-method"
               [class.selected]="paymentForm.method === 'Prepaid'"
               (click)="selectPaymentMethod('Prepaid')">
            <div class="method-content">
              <div class="method-icon" *ngIf="!showMorePaymentMethods">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="method-info">
                <div class="method-title">Prepaid</div>
                <div class="method-description">Use prepaid balance for payment</div>
              </div>
            </div>
            <div class="method-radio" [class.checked]="paymentForm.method === 'Prepaid'"></div>
          </div>

          <div class="payment-method"
               [class.selected]="paymentForm.method === 'Everwash Membership'"
               (click)="selectPaymentMethod('Everwash Membership')">
            <div class="method-content">
              <div class="method-icon" *ngIf="!showMorePaymentMethods">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="method-info">
                <div class="method-title">Everwash Membership</div>
                <div class="method-description">Use Everwash membership for payment</div>
              </div>
            </div>
            <div class="method-radio" [class.checked]="paymentForm.method === 'Everwash Membership'"></div>
          </div>

          <div class="payment-method"
               [class.selected]="paymentForm.method === 'Way.com Membership'"
               (click)="selectPaymentMethod('Way.com Membership')">
            <div class="method-content">
              <div class="method-icon" *ngIf="!showMorePaymentMethods">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="method-info">
                <div class="method-title">Way.com Membership</div>
                <div class="method-description">Use Way.com membership for payment</div>
              </div>
            </div>
            <div class="method-radio" [class.checked]="paymentForm.method === 'Way.com Membership'"></div>
          </div>
        </ng-container>

        <div class="more-payment-methods-toggle" (click)="toggleMorePaymentMethods()">
          <span>{{ showMorePaymentMethods ? 'Less Payment Methods' : 'More Payment Methods' }}</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" [class.rotated]="showMorePaymentMethods">
            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Stripe card form -->
      <div *ngIf="paymentForm.method === PaymentMethodCode.Card" class="card-payment-form">
        <div class="stripe-form-container">
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Name on card<span class="asterisk">*</span></label>
              <div class="stripe-input-container">
                <input type="text" class="stripe-input-field" placeholder="e.g. John Smith"
                       autocomplete="cc-name" [(ngModel)]="paymentForm.cardholderName" name="cardholderName">
              </div>
            </div>
            <div class="form-field">
              <label class="field-label">Card number<span class="asterisk">*</span></label>
              <div class="stripe-input-container">
                <div id="card-number" class="stripe-input-field"></div>
              </div>
              <div id="card-number-error" class="field-error" role="alert"></div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Expiration<span class="asterisk">*</span></label>
              <div class="stripe-input-container"><div id="card-expiry" class="stripe-input-field"></div></div>
              <div id="card-expiry-error" class="field-error" role="alert"></div>
            </div>
            <div class="form-field">
              <label class="field-label">CVC<span class="asterisk">*</span></label>
              <div class="stripe-input-container"><div id="card-cvc" class="stripe-input-field"></div></div>
              <div id="card-cvc-error" class="field-error" role="alert"></div>
            </div>
          </div>
          <div class="form-field">
            <label class="field-label">Billing address</label>
            <div class="stripe-input-container">
              <input type="text" class="stripe-input-field" placeholder="e.g. 122B, Baker Street, NYC"
                     [(ngModel)]="paymentForm.billingAddress" name="billingAddress">
            </div>
          </div>
        </div>
      </div>

      <!-- Payment link phone field -->
      <div *ngIf="paymentForm.method === PaymentMethodCode.Link" class="phone-input-section">
        <app-custom-input
          label="Phone Number"
          placeholder="e.g. 212 555-1234"
          type="tel"
          [required]="true"
          [validationRules]="paymentPhoneValidation"
          [showValidation]="true"
          [(value)]="paymentForm.phoneNumber">
        </app-custom-input>
        <div *ngIf="paymentLinkError" class="error-message">{{ paymentLinkError }}</div>
      </div>

    </div>

    <!-- Actions -->
    <div class="payment-actions">
      <button class="cancel hide-cancel-mobile" (click)="cancel.emit()">Cancel</button>
      <div class="footer-right">
        <button class="back" type="button"
                [disabled]="isProcessingPayment || isCreatingPaymentLink"
                (click)="back.emit()">
          Back
        </button>

        <!-- Tap to Pay / Card / Payment Link -->
        <button *ngIf="paymentForm.method !== PaymentMethodCode.Cash && paymentForm.method !== 'DRB Membership' && paymentForm.method !== 'Prepaid' && paymentForm.method !== 'Everwash Membership' && paymentForm.method !== 'Way.com Membership'"
                class="send-link"
                [disabled]="!orderId || isProcessingPayment || isCreatingPaymentLink || !canProceedWithCurrentMethod"
                (click)="paymentForm.method === PaymentMethodCode.TapToPay ? onTapToPayClick() : paymentForm.method === PaymentMethodCode.Card ? onCardCheckout() : onCreatePaymentLink()">
          <span *ngIf="!isProcessingPayment && !isCreatingPaymentLink">
            {{ paymentForm.method === PaymentMethodCode.TapToPay ? 'Proceed' : paymentForm.method === PaymentMethodCode.Card ? 'Checkout' : 'Send Link' }}
          </span>
          <span *ngIf="isProcessingPayment" class="loading-content"><div class="loading-spinner"></div> Processing...</span>
          <span *ngIf="isCreatingPaymentLink" class="loading-content"><div class="loading-spinner"></div> Creating Link...</span>
        </button>

        <!-- Cash / Membership confirmation -->
        <button *ngIf="paymentForm.method === PaymentMethodCode.Cash || paymentForm.method === 'DRB Membership' || paymentForm.method === 'Prepaid' || paymentForm.method === 'Everwash Membership' || paymentForm.method === 'Way.com Membership'"
                class="send-link"
                [disabled]="isConfirmingCashPayment || !orderId"
                (click)="confirmPaymentMode(paymentForm.method)">
          <span *ngIf="!isConfirmingCashPayment">Confirm Payment</span>
          <span *ngIf="isConfirmingCashPayment" class="loading-content"><div class="loading-spinner"></div> Confirming...</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Payment link sent modal -->
<app-payment-link-sent-modal
  *ngIf="showPaymentLinkSentModal"
  [isOpen]="showPaymentLinkSentModal"
  [phoneNumber]="paymentForm.phoneNumber"
  [isResending]="isCreatingPaymentLink"
  (close)="onPaymentLinkSentClose()"
  (cancelPayment)="onCancelPayment()"
  (resendLink)="onResendPaymentLink()">
</app-payment-link-sent-modal>
